import React, { useMemo } from 'react';

import type { Ticket } from '@rtkwlf/rendall';
import Papa from 'papaparse';
import { useTranslation } from 'react-i18next';

import { CsvExport } from '@packages/components/csv-export/csv-export';
import { useOrganizationContext } from '@packages/legacy/organization-context';

type TicketExportProps = {
  data?: Required<Ticket>[];
};

export const TicketExport: React.FC<TicketExportProps> = ({ data }) => {
  const { t } = useTranslation();
  const { selectedOrganization } = useOrganizationContext();

  const csvText = useMemo(() => {
    if (!data?.length) {
      return '';
    }

    const csv = Papa.unparse({
      data: data.map((row) => [
        row.id,
        row.subject,
        row.status,
        row.type,
        row.requester,
        row.cc,
        row.createdAt,
        row.updatedAt,
      ]),
      fields: [
        t('ticket:details.ticketId'),
        t('ticket:ticketSubject'),
        t('ticket:details.status'),
        t('ticket:details.ticketType'),
        t('ticket:details.to'),
        t('ticket:details.cc'),
        t('ticket:details.created'),
        t('ticket:details.lastUpdated'),
      ],
    });

    return csv;
  }, [data, t]);

  return (
    <CsvExport
      variant="tertiary"
      data={csvText}
      fileName={`${t('ticket:title')}_${selectedOrganization.name}`}
      isDisabled={!csvText}
    />
  );
};
